/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */
import 'reflect-metadata'
import "./setupAppMain.js"
import {Vue, routerManager} from "./importFull.js"

console.log("createApp: main.js")

Vue.use(routerManager.router)


console.log("main.js")
routerManager.router.isReady().then(() => {
	console.log("main.js: routerManager router is ready")
	Vue.mount('#app')
	setTimeout(() => {
		document.dispatchEvent(new Event('prerender-start'))
	}, 1000)
}).catch(error => console.error("routerManager.router.isReadygenogra error = ", error))


// let loadFullStyles = () => import ('./importFull.js')
// loadFullStyles().then((module) => {
// 	let {Vue, routerManager} = module.default
// 	// import {Vue, routerManager} from "./importFull.js"
//
// 	routerManager.router.isReady().then(() => {
// 		Vue.mount('#app')
// 		setTimeout(() => {
// 			document.dispatchEvent(new Event('prerender-start'))
// 		}, 1000)
// 	}).catch(error => console.error("routerManager.router.isReadygenogra error = ", error))
// })
